import "./AboutUs.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import NuestraHistoriaYMisiN from "./sections/NuestraHistoriaYMisiN";
import CertificacionesYPermisos from "./sections/CertificacionesYPermisos";
import VentajasQueNosDistinguen from "./sections/VentajasQueNosDistinguen";
import InformaciNCorporativa from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <NavegaciNPrincipal />
      <NuestraHistoriaYMisiN />
      <CertificacionesYPermisos />
      <VentajasQueNosDistinguen />
      <InformaciNCorporativa />
    </div>;
}